import { Add, Remove } from "@mui/icons-material";
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import KeyPointsIcon from "../../../../../../../../assets/VideoEditing/icons/KeyPointsIcon";
import BriaAccordion from "../../../../../../../../components/common/BriaAccordion/BriaAccordion";
import StoppableButton from "../../../../../../../../components/common/StoppableButton/StoppableButton";
import { useAppStore } from "../../../../../../../../hooks/useStores";
import { KeyPointType } from "../../../../../../../Playground/VideoGeneration/video-generation-store";
import { ActiveTab } from "../../VideoEraserPopup";
import styles from "../VideoEraserPopupConfig.module.scss";

type VideoEraserKeyPointsProps = {
	activeTab: ActiveTab | undefined;
	setActiveTab: (tab: ActiveTab | undefined) => void;
};

const VideoEraserKeyPoints = ({ activeTab, setActiveTab }: VideoEraserKeyPointsProps) => {
	const { t } = useTranslation("video_editing", { keyPrefix: "lab.config.tools.erase.popup.config.keyPoints" });
	const { videoGenerationStore } = useAppStore();
	const pointType: KeyPointType = videoGenerationStore.keypointBrushConfigs.brushMode as KeyPointType;

	const generateMask = () => {
		videoGenerationStore.generateMaskByKeyPoints();
	};

	const handlePointTypeChange = (_: React.MouseEvent<HTMLElement>, newPointType: KeyPointType | null) => {
		if (newPointType !== null) {
			videoGenerationStore.keypointBrushConfigs.brushMode = newPointType;
		}
	};

	return (
		<BriaAccordion
			// disabled={true}
			expanded={activeTab === "keyPoints"}
			onChange={(_, expanded: boolean) => setActiveTab(expanded ? "keyPoints" : undefined)}
			accordionTitle={
				<Box className={styles.accordionTitleContainer}>
					<KeyPointsIcon className={styles.icon} />
					<Typography className={styles.accordionTitleText}>{t("label")}</Typography>
					{/* <Box className={styles.comingSoon}>{t("comingSoon")}</Box> */}
				</Box>
			}
			titleClass={styles.accordionTitle}
			useSecondaryIcons
		>
			<Box className={styles.content}>
				<Box className={styles.instructions}>
					<Box className={styles.description}>{t("instructions.title")}</Box>
					<Box className={styles.description}>{t("instructions.description")}</Box>
				</Box>

				<Box className={styles.editKeypointsContainer}>
					<Typography className={styles.editKeypointsLabel}>{t("editKeypoints.label")}</Typography>
					<ToggleButtonGroup
						className={styles.editKeypointsButtonGroup}
						value={pointType}
						onChange={handlePointTypeChange}
						exclusive
					>
						<ToggleButton value="point" className={styles.editKeypointsButton}>
							<Add />
							{t("editKeypoints.addButton")}
						</ToggleButton>
						<ToggleButton value="point-erase" className={styles.editKeypointsButton}>
							<Remove />
							{t("editKeypoints.removeButton")}
						</ToggleButton>
					</ToggleButtonGroup>
				</Box>
				<StoppableButton
					condition={videoGenerationStore.isGeneratingMask}
					onStopButtonClick={() => videoGenerationStore.abortVideoSegmentation()}
					onButtonClick={generateMask}
					buttonLabel={t("generateButton")}
					stopButtonLabel={t("stopGenerate")}
					disabled={!videoGenerationStore.segmentConfig?.key_points?.length}
				/>
			</Box>
		</BriaAccordion>
	);
};

export default observer(VideoEraserKeyPoints);
